import { upperFirst } from "lodash";
import { Hotkey } from "react-hotkeys-hook/dist/types";

type ScreenshotHotKeys = {
  keysUp?: string[];
  keysDown?: string[];
};

export function getScreenshotHotKeys(
  lowercasedOsName: string,
): ScreenshotHotKeys {
  if (lowercasedOsName === "windows") {
    return {
      keysUp: ["PrintScreen", "meta+shift+s"],
      keysDown: ["ctrl+shift+s"],
    };
  } else if (lowercasedOsName === "macos") {
    // screenshot hotkeys detection is disabled on MacOS
    // because the OS intercept the key events
    return {};
  } else if (lowercasedOsName === "linux") {
    return { keysUp: ["PrintScreen", "shift+control+alt+r"] };
  }

  // Turn off screenshot hotkeys detection for unknown OS
  return {};
}

export function getPressedKeys(hotkeyEvent: Hotkey, lowercasedOsName: string) {
  const pressedKeys = [];

  const isMac = lowercasedOsName === "macos";
  const isWindows = lowercasedOsName === "windows";

  if (hotkeyEvent.alt) {
    pressedKeys.push(isMac ? "Option" : "Alt");
  }
  if (hotkeyEvent.ctrl) {
    pressedKeys.push("Control");
  }
  if (hotkeyEvent.shift) {
    pressedKeys.push("Shift");
  }
  if (hotkeyEvent.meta) {
    pressedKeys.push(isWindows ? "Windows" : isMac ? "Command" : "Meta");
  }
  pressedKeys.push(...(hotkeyEvent.keys?.map((key) => upperFirst(key)) || []));

  return pressedKeys;
}
